import React, { useState } from "react";
import { Box, Button, Card } from "@mui/material";
import ArrowBack from "@mui/icons-material/ArrowBack";
import { buttonPosition, boxStyle } from "../style/style";
import AddToQueueIcon from "@mui/icons-material/AddToQueue";
import Dialog from "@mui/material/Dialog";
import AddDistributor from "./AddDistributor";
import OrgList from "./DistributorComponent/OrgList";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import Tabs from "@mui/material/Tabs";
import TabPanel from "@mui/lab/TabPanel";
import DistributorProfile from "./DistributorComponent/DistributorProfile";
import AddDistributorUser from "./DistributorComponent/AddDistributorUser";
import DistributorUserList from "./DistributorComponent/DistributorUserList";

export default function DistributorDetail(props) {
  const [open, setopen] = useState(false);
  const [refresh, setrefresh] = useState(false);
  const [value, setvalue] = useState("1");
  const [adduser, setadduser] = useState(false);

  const handleChange = (val) => {
    props.search.setsearch("");
    setvalue(val);
  };

  return (
    <div>
      <Card sx={boxStyle}>
        <TabContext value={value}>
          <Box sx={boxStyle}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
                value={value}
                //onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  label="Profile"
                  value={"1"}
                  onClick={() => handleChange("1")}
                />
                <Tab
                  label="users"
                  value={"2"}
                  onClick={() => handleChange("2")}
                />
                <Tab
                  label="Organizations"
                  value={"3"}
                  onClick={() => handleChange("3")}
                />
              </Tabs>
            </Box>
            <Button
              sx={{ float: "left" }}
              onClick={() => {
                props.setrefresh(!props.refresh)
                props.setdetail(false);
              }}
              startIcon={<ArrowBack />}
            ></Button>
            <Box
              m={2}
              sx={buttonPosition}
              //margin
            >
              {value !== "1" && (
                <Button
                  variant={"contained"}
                  color={"primary"}
                  startIcon={<AddToQueueIcon />}
                  onClick={() => {
                    if (value === "2") {
                      setopen(false);
                      setadduser(true);
                    } else {
                      setadduser(false);
                      setopen(true);
                    }
                  }}
                >
                  {value === "2" ? "add User" : "Add Organization"}
                </Button>
              )}
            </Box>
            <TabPanel value={"1"}>
              <DistributorProfile
                distributor={props.distributor}
                setdistributor={props.setdistributor}
                setdistributorname={props.distriburotname.setdistributorname}
              />
            </TabPanel>
            <TabPanel value="2">
              <DistributorUserList
                id={props.id}
                setrefresh={setrefresh}
                refresh={refresh}
                search_refresh={props.refresh}
                search={props.search}
              />
            </TabPanel>
          </Box>
          <TabPanel value="3">
            <OrgList
              id={props.id}
              setrefresh={setrefresh}
              refresh={props.refresh}
              search={props.search}
              add_org_refresh={refresh}
            />
          </TabPanel>

          <Dialog
            open={open}
            onClose={() => {
              setopen(false);
            }}
          >
            <AddDistributor
              setopen={setopen}
              id={props.id}
              setrefresh={setrefresh}
              refresh={refresh}
            />
          </Dialog>
          <Dialog
            open={adduser}
            onClose={() => {
              setadduser(false);
            }}
          >
            <AddDistributorUser
              setadduser={setadduser}
              id={props.id}
              setrefresh={setrefresh}
              refresh={refresh}
            />
          </Dialog>
        </TabContext>
      </Card>
    </div>
  );
}
